/* eslint-disable */
/* tslint:disable */
import * as React from 'react';
export interface WidgetArrowLeftProps extends React.SVGAttributes<SVGElement> {
size?: string;
}
const WidgetArrowLeft: React.SFC<WidgetArrowLeftProps> = ({size, ...props}) => (
  <svg viewBox="0 0 7 11" fill="currentColor" width={ size || "7" } height={ size || "11" } {...props}>
    <path stroke="currentColor" transform="scale(-1 1) rotate(45 0 -10.192)" d="M3 2.02904564L10 2 9.97095436 9" fill="none" fillRule="evenodd" />
  </svg>
);
WidgetArrowLeft.displayName = 'WidgetArrowLeft';
export default WidgetArrowLeft;
/* tslint:enable */
/* eslint-enable */
